@if (item.value !== null) {
  <div class="value"
    (click)="onClick(item.value)">
    {{ item.value[labelKey] }}
  </div>
} @else {
  <div class="group unclickable">
    {{ item.key }}
  </div>
}
